module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/photography.4a5cb52d.jpg";